<template>
  <div class="state-details">
    <template v-if="currentState">
      <h3 class="state-title">
        {{ currentState.name }}
      </h3>

      <p class="state-description">
        <img :src="currentState.flag_image" class="state-flag" />

        {{ currentState.description }}
      </p>
    </template>
    <template v-else>
      <h3 class="state-title">
        What are your state's favorite fragrances?
      </h3>

      <p>
        Find out by selecting your state on the map to the left,
        or by using the dropdown box below. Browse nearby states
        to see what's popular in your area of the country,
        and maybe even discover an in-demand scent to add to your line!
      </p>
    </template>
  </div>
</template>

<script>
  export default {
    computed: {
      currentState() {
        return this.$store.getters.currentState;
      }
    }
  };
</script>
